import baustein from "baustein";
import environment from "web/script/modules/environment";
import analytics from "web/script/analytics/analytics";
import doubleclickEvents from "web/script/analytics/doubleclick-events";


export default baustein.register("lyst-checkout", {
    init: function() {
        if (environment.get("doubleclickEvent")) {
            this._trackDoubleclickEvent();
        }
    },

    _trackDoubleclickEvent: function() {
        var event = environment.get("doubleclickEvent");
        analytics.tagEvent(
            analytics.TAG_NETWORKS.DOUBLECLICK,
            doubleclickEvents[event.name],
            event.data
        );
    },
});
